import { Keyword } from '@livv/models';
import { Tooltip, Typography } from '@mui/material';
import { FC } from 'react';
import LinksTitles from './LinksTitles';

interface KeywordTooltipProps {
    keyword: Keyword;
    onClick: () => void;
    theme: string;
    titles: string[];
}

const KeywordTooltip: FC<KeywordTooltipProps> = ({ keyword, onClick, theme, titles }) => {
    const maxTitleItems = 3;

    return (
        <Tooltip
            componentsProps={{
                tooltip: { sx: { fontSize: 'caption.fontSize', fontWeight: 'regular', p: 2 } },
            }}
            title={
                <LinksTitles keyword={keyword} onClick={onClick} theme={theme} titles={titles} />
            }
        >
            <Typography
                component="div"
                sx={{ color: 'grey.300', fontSize: 'caption.fontSize', lineHeight: 1, my: 2 }}
            >
                <LinksTitles
                    keyword={keyword}
                    maxTitleItems={maxTitleItems}
                    onClick={onClick}
                    theme={theme}
                    titles={titles}
                />
                {titles.length > maxTitleItems && '[…]'}
            </Typography>
        </Tooltip>
    );
};

export default KeywordTooltip;
